// test18
(18 && 0);
